import images from './Images'

const winter = {
  quizLetters: images.quizLetters,
  quizInfo: images.quizInfo,
  firstLevel: images.firstLevel,
  secondLevel: images.secondLevel,
  thirdLevel: images.thirdLevel,
  background1: images.background1,
  background2: images.background2,
  background3: images.background3,
  quizRibbon: images.quizRibbon,
  thumbsUp: images.thumbsUp,
  thumbsDown: images.thumbsDown,
  sadFace: images.sadFace,
  starlessIcon: images.starlessIcon,
  successLottie: images.lottie_celebrate,
  gradient: ['#BADDFF', '#6695CE'],
  primary: '#152439',
}

const summer = {
  quizLetters: images.quizLetters,
  quizInfo: images.quizInfo,
  firstLevel: images.firstLevel,
  secondLevel: images.secondLevel,
  thirdLevel: images.thirdLevel,
  background1: images.background1,
  background2: images.background2,
  background3: images.background3,
  quizRibbon: images.quizRibbon,
  thumbsUp: images.thumbsUp,
  thumbsDown: images.thumbsDown,
  sadFace: images.sadFace,
  starlessIcon: images.starlessIcon,
  successLottie: images.lottie_celebrate,
  gradient: ['#C57E66', '#BADDFF'],
  primary: '#152439',
}

export { winter, summer }
